import React, { useState, useEffect } from "react";
import { Sparkle } from "lucide-react";

// Illustrative social-proof nudges (not live data) — subtle growth cue.
const CITIES = ["Brooklyn", "Austin", "London", "San Francisco", "Toronto", "Paris", "Miami", "Seattle", "Dubai", "Sydney"];
const VERBS = [
  "A Maison Experience was just sent from",
  "A Royal Voice card was curated in",
  "A cash gift was claimed in",
  "A Sovereign Seal was minted in",
];

const SocialProof = () => {
  const [msg, setMsg] = useState(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    let idx = 0;
    const show = () => {
      const verb = VERBS[Math.floor(Math.random() * VERBS.length)];
      const city = CITIES[idx % CITIES.length]; idx += 1;
      setLeaving(false);
      setMsg(`${verb} ${city}.`);
      // auto-hide after 4.5s
      setTimeout(() => setLeaving(true), 4500);
      setTimeout(() => setMsg(null), 4900);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 9000);
    return () => { clearTimeout(first); clearInterval(interval); };
  }, []);

  if (!msg) return null;
  return (
    <div data-testid="social-proof" className={`fixed bottom-5 left-5 z-40 ${leaving ? "proof-out" : "proof-in"}`}>
      <div className="surface rounded-2xl px-4 py-2.5 flex items-center gap-2.5 shadow-lg max-w-[300px]">
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center shrink-0">
          <Sparkle className="w-3.5 h-3.5 text-white" />
        </div>
        <span className="text-sm text-foreground/90 leading-snug">{msg}</span>
      </div>
    </div>
  );
};

export default SocialProof;
